module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/ladder-d9f06bea897cb79d8bc1c51188a6dccc.svg";